import React from 'react';

const Filters = () => {
  const filterProducts = [
    
    { name: "Pleated Filters", image: "images/jalistep/pic9.jpg" },
    { name: "Spun/PP Filters", image: "images/jalistep/pic5.jpg" },
    { name: "CTO Filters", image: "images/jalistep/pic23 (70).png" },
    { name: "GAC Filters", image: "images/jalistep/pic23 (28).png" },
    { name: "Wound filters", image: "images/jalistep/wound filters.jpeg" },
    { name: "Filter Housing", image: "images/jalistep/Filter housing.png" }
  ];

  return (
    <div className="container py-5">
      <h1 className="text-center mb-5 text-dark">FILTERS</h1>
      
      <div className="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-4">
        {filterProducts.map((product, index) => (
          <div key={index} className="col">
            <div className="card h-100 shadow-sm border-0 text-center">
              <img 
                src={product.image} 
                alt={product.name}
                className="card-img-top p-3"
                style={{ height: "200px", objectFit: "contain" }}
              />
              <div className="card-body">
                <h5 className="card-title text-cyan m-0">{product.name}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Filters;